import { service } from '../../../service';

const state = {
  loading: false,
  items: []
};

const actions = {
  fetch({ commit, rootState }) {
    commit('setLoading', true);

    return service
      .get(`/templates/${rootState.account.company._id}`)
      .then(result => commit('setItems', result.templates));
  },

  async create({ dispatch, commit, rootState }, payload) {
    return service
      .post(`/templates/${rootState.account.company._id}`, payload)
      .then(result => {
        commit('newItem', result.template);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  async update({ dispatch, commit, rootState }, payload) {
    return service
      .patch(
        `/templates/${rootState.account.company._id}/${payload._id}`,
        payload
      )
      .then(result => {
        commit('updateItem', result.template);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  async delete({ dispatch, commit, rootState }, id) {
    return service
      .delete(`/templates/${rootState.account.company._id}/${id}`)
      .then(result => {
        commit('deleteItem', result.id);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  }
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setItems(state, items) {
    state.items = items;
    state.loading = false;
  },
  newItem(state, item) {
    state.items.push(item);
    state.loading = false;
  },
  updateItem(state, item) {
    var index = state.items.findIndex(i => {
      return i._id === item._id;
    });
    if (index !== -1) {
      state.items.splice(index, 1, item);
    }
    state.loading = false;
  },
  deleteItem(state, id) {
    var index = state.items.findIndex(item => {
      return item._id === id;
    });
    if (index !== -1) {
      state.items.splice(index, 1);
    }
    state.loading = false;
  }
};

export const templates = {
  namespaced: true,
  state,
  actions,
  mutations
};
